'use client';

import type { JSX } from 'react';
import { LazyLottie } from '../lazy-lottie';

interface IEmptyStateProps {
  title: string;
  description?: string;
}

export function EmptyState({ title, description }: IEmptyStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <LazyLottie src="/lottie/balloon-dance.lottie.json" className="h-112 w-md" />
      <h3 className="mt-2 text-lg font-semibold">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-center text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  );
}

export function EmptyTable({ title, description }: IEmptyStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <LazyLottie src="/lottie/no-data.lottie.json" className="h-72 w-72" />
      <h3 className="mt-2 text-lg font-semibold">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-center text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  );
}
